<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M5 4C5 2.34315 6.34315 1 8 1H12C13.6569 1 15 2.34315 15 4V8C15 9.65685 13.6569 11 12 11H7C5.89543 11 5 10.1046 5 9V4Z"
        stroke="var(--icon-color)" stroke-width="2" />
    <path
        d="M11 15C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V15ZM3 5C3 4.44772 2.55228 4 2 4C1.44772 4 1 4.44772 1 5H3ZM11 13H5V15H11V13ZM3 11V5H1V11H3ZM5 13C3.89543 13 3 12.1046 3 11H1C1 13.2091 2.79086 15 5 15V13Z"
        fill="var(--icon-color)" />
</svg>
